import { defineMutation, useMutation } from '@pinia/colada';

import { useAlertsStore } from '@tallo/design-system';

import { SubmitConversationFeedbackPayload } from '../models/message-feedback.interface';
import conversationService from '../services/conversation.service';

export const useSubmitConversationFeedbackMutation = defineMutation(() => {
  return useMutation({
    mutation(payload: SubmitConversationFeedbackPayload) {
      return conversationService.submitConversationFeedback(payload);
    },

    onSuccess() {
      useAlertsStore().success('Thanks — shared with Tallo.');
    },

    onError(error) {
      useAlertsStore().catchError(error);
    },
  });
});
